import ReactDOM from 'react-dom/server'
import React from 'react'
import Typography from 'typography'
import { MOBILE_MEDIA_QUERY } from 'typography-breakpoint-constants'

const options = {
  baseFontSize: '16px',
  baseLineHeight: '24px',
  scaleRatio: 2.25,
  googleFonts: [
    {
      name: 'Marcellus SC',
      styles: ['400'],
    },
    {
      name: 'Open Sans',
      styles: ['400', '400i', '700'],
    },
  ],
  headerFontFamily: ['Marcellus SC', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
  bodyFontFamily: ['Open Sans', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
  headerColor: 'hsla(0,0%,0%,0.9)',
  bodyColor: 'hsla(0,0%,0%,0.73)',
  headerWeight: '400',
  bodyWeight: 400,
  boldWeight: 700,
  overrideStyles: ({ adjustFontSizeTo, rhythm, scale }, options) => ({
    'h1,h2,h3,h4,h5,h6': {
      textTransform: 'uppercase',
    },
    'a': {
      color: '#1c943b',
      fontStyle: 'italic',
      textDecoration: 'none',
    },
    'p': {
      lineHeight: '1.5',
    },
    [MOBILE_MEDIA_QUERY]: {
      // Make baseFontSize on mobile 14px.
      html: {
        fontSize: `${14 / 16 * 100}%`,
      },
    },
  }),
}

const typography = new Typography(options)

// Hot reload typography in development.
if (process.env.NODE_ENV !== 'production') {
  typography.injectStyles()
}

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js